import { KnownDeliveryDtoState, KnownOrderDtoStatus, KnownOrderStatus } from '@groundfloor-platform/mgmt-service-g-sdk';
import { Colors } from '../../ui/theme/colors';
import { getOrderStatusLabel, getOrderStatusLabelWithCategory } from '../../core/util/status-label.util';
import { BookingFlowType } from '../../ui/enums/booking-flow-type.enum';

export const orderStatusBackgroundColors: Record<KnownOrderDtoStatus | KnownDeliveryDtoState, string> = {
  booked: Colors.bookedScannedInProgressGray,
  'in-progress': Colors.bookedScannedInProgressGray,
  overdue: Colors.overdueOrange,
  delivered: Colors.deliveredBlue,
  'delivered-offline': Colors.bookedScannedInProgressGray,
  collected: Colors.collectedGreen,
  cancelled: Colors.cancelledDeletedRed,
  'retrieval-required': Colors.retrievalRequiredPurple,
  retrieved: Colors.retrievedPurple,
  abandoned: Colors.cancelledDeletedRed
};

export const orderStatusToLabel: Record<KnownOrderDtoStatus, string> = {
  booked: 'Booked',
  'in-progress': 'In Progress',
  delivered: 'Delivered',
  'delivered-offline': 'Delivered Offline',
  overdue: 'Overdue',
  collected: 'Collected',
  'retrieval-required': 'Retrieval Required',
  cancelled: 'Cancelled',
  retrieved: 'Retrieved'
};

export const orderStatusToLabelWithCategory: Record<CustomOrderStatusOptions, string> = {
  booked: '- Booked',
  delivered: '- Delivered',
  overdue: '- Overdue',
  collected: '- Collected',
  'retrieval-required': '- Retrieval Required',
  cancelled: '- Cancelled',
  retrieved: '- Retrieved',
  completed: 'Completed',
  'not-delivered': 'Not Delivered',
  'delivered-offline': '- Delivered Offline',
  'current-deliveries-category': 'Current'
};

export enum CustomOrderStatusOptions {
  Booked = 'booked',
  Delivered = 'delivered',
  Overdue = 'overdue',
  Collected = 'collected',
  RetrievalRequired = 'retrieval-required',
  Retrieved = 'retrieved',
  Cancelled = 'cancelled',
  Completed = 'completed',
  NotDelivered = 'not-delivered',
  DeliveredOffline = 'delivered-offline',
  CurrentDeliveriesCategory = 'current-deliveries-category'
}

export const OptionsToValuesMap: Record<CustomOrderStatusOptions, KnownOrderStatus[]> = {
  'not-delivered': [KnownOrderStatus.Booked, KnownOrderStatus.Cancelled, KnownOrderStatus.DeliveredOffline],
  'delivered-offline': [KnownOrderStatus.DeliveredOffline],
  booked: [KnownOrderStatus.Booked],
  'current-deliveries-category': [
    KnownOrderStatus.Delivered,
    KnownOrderStatus.Overdue,
    KnownOrderStatus.RetrievalRequired
  ],
  delivered: [KnownOrderStatus.Delivered],
  overdue: [KnownOrderStatus.Overdue],
  collected: [KnownOrderStatus.Collected],
  'retrieval-required': [KnownOrderStatus.RetrievalRequired],
  retrieved: [KnownOrderStatus.Retrieved],
  cancelled: [KnownOrderStatus.Cancelled],
  completed: [KnownOrderStatus.Collected, KnownOrderStatus.Retrieved]
};

/**
 * Get order status label with booking flow type consideration
 */
export function getOrderStatusLabelWithFlowType(status: KnownOrderDtoStatus, bookingFlowType: BookingFlowType): string {
  return getOrderStatusLabel(status, bookingFlowType);
}

/**
 * Get order status label with category and booking flow type consideration
 */
export function getOrderStatusLabelWithCategoryAndFlowType(
  status: KnownOrderDtoStatus,
  bookingFlowType: BookingFlowType
): string {
  return getOrderStatusLabelWithCategory(status, bookingFlowType);
}
